import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IMetadataContext } from './types';

export default createContext<IMetadataContext>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
